import { Filter, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Table, TBody, TD, TH, THead, TR } from '@/components/ui/table'
import { usePeriod, useSalesReport } from '../api'
import { ReportCard } from '../components/ReportBits'
import { ReportLayout } from '../components/ReportLayout'

export function SalesReportPage() {
  const { t } = useTranslation()
  const { months } = usePeriod()
  const q = useSalesReport(months)
  const r = q.data

  return (
    <ReportLayout name="satis" title={t('reports.pages.sales.title')} description={t('reports.pages.sales.subtitle')} query={q}>
      {r ? (
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
          <ReportCard icon={Filter} title={t('reports.sales.funnel')} description={t('reports.sales.funnelHint')}>
            <p className="mb-3 text-sm text-muted-foreground">
              %{r.funnel.winRatePercent} · {r.funnel.wonInPeriod} / {r.funnel.lostInPeriod}
            </p>
            <ol className="space-y-2">
              {r.funnel.stages.map((f) => {
                const max = r.funnel.stages[0]?.accounts || 1
                return (
                  <li key={f.code || f.name}>
                    <div className="relative h-10 overflow-hidden rounded-lg bg-muted">
                      <div className="absolute inset-y-0 left-0 rounded-lg bg-[var(--series-1)]/85" style={{ width: `${Math.max(6, (f.accounts / max) * 100)}%` }} />
                      <div className="relative flex h-full items-center justify-between px-3 text-sm">
                        <span className="font-medium">{f.name || f.code}</span>
                        <span className="font-semibold tabular-nums">{f.accounts}</span>
                      </div>
                    </div>
                  </li>
                )
              })}
            </ol>
          </ReportCard>
          <ReportCard icon={Users} title={t('reports.sales.reps')} description={t('reports.sales.repsHint')}>
            <Table>
              <THead>
                <TR>
                  <TH>{t('reports.col.rep')}</TH>
                  <TH className="text-right">{t('reports.col.customers')}</TH>
                  <TH className="text-right">{t('reports.series.meetings')}</TH>
                  <TH className="text-right">{t('reports.series.won')}</TH>
                  <TH className="text-right">{t('reports.col.winRate')}</TH>
                </TR>
              </THead>
              <TBody>
                {r.reps.map((rep) => (
                  <TR key={rep.userId || rep.name}>
                    <TD>{rep.name}</TD>
                    <TD className="text-right tabular-nums">{rep.accountsOwned}</TD>
                    <TD className="text-right tabular-nums">{rep.meetingsHeld}</TD>
                    <TD className="text-right tabular-nums">{rep.won}</TD>
                    <TD className="text-right tabular-nums">%{rep.winRatePercent}</TD>
                  </TR>
                ))}
              </TBody>
            </Table>
          </ReportCard>
        </div>
      ) : null}
    </ReportLayout>
  )
}
